var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import { useState, useEffect } from 'react';
import get from 'lodash/get';

/**
 * This is a custom hook to determine if the text has overflown the width of the container.
 * Useful only with CSS `text-overflow: ellipsis;`.
 * TODO: This is a useful utility, we can expose this through Path.
 */
function useTextOverflow(elementRef, selector) {
    var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        overflow = _useState2[0],
        setOverflow = _useState2[1];

    useEffect(function () {
        var element = selector ? get(elementRef, 'current') && elementRef.current.querySelector(selector) : elementRef.current;

        if (element && element.offsetWidth < element.scrollWidth) {
            setOverflow(true);
        }
    }, [elementRef, selector]);

    return [overflow, setOverflow];
}

export default useTextOverflow;